import { useState, useEffect } from 'react';
import { useToast } from '../../Utils/toastContext';
import { useSelector } from 'react-redux';
import CertificateManagement from '../../Pages/Customer/certificate-management';
import { useNavigate, useLocation } from 'react-router-dom';
import ComplianceDashboard from './compliance-dashboard';
import AgencyDashboard from './agency-dashboard';
import AuditorDashboard from './auditor-dashboard';
import BusinessDashboard from './business-dashboard';

import AgentDashboard from './agent-dashboard';
const DashboardDetails = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const roleName = useSelector((state) => state.user.roleName);
  const [isOpenShare, setisOpenShare] = useState(false);
  const navigate = useNavigate();
  const [isOpenManageAccess, setisOpenManageAccess] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [tableData, setTableData] = useState([
    {
      id: 1,
      name: 'John Daniel',
      email: 'john.doe@example.com',
      viewCertificate: true,
      viewDocument: true,
      downloadDocument: true,
    },
  ]);

  const [searchQuery, setSearchQuery] = useState('');
  const [email, setEmail] = useState('');
  const [showRecords, setShowRecords] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages] = useState(10);
  const [totalCount] = useState(10);
  const [data, setData] = useState([]);
  const [isLoadingCard, setIsLoadingCard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [clientName, setClientName] = useState('');

  const handleGenerateReport = () => {
    if (!clientName) return alert('Enter client name');
    console.log('Generate report for:', clientName);
    setShowModal(false);
  };
  const statsConfigAgency = [
    {
      key: 'agents',
      title: 'Total Team Members',
      icon: 'support_agent',
      gradient: 'from-green-500 to-emerald-600',
    },
    {
      key: 'compliance_officers',
      title: 'Compliance Officers',
      icon: 'verified_user',
      gradient: 'from-yellow-500 to-orange-500',
    },
    {
      key: 'customers',
      title: 'Customers',
      icon: 'groups',
      gradient: 'from-cyan-500 to-blue-500',
    },
    {
      key: 'certificates',
      title: 'Certificates',
      icon: 'workspace_premium',
      gradient: 'from-rose-500 to-red-500',
    },
  ];
  const statsConfigAgent = [
    {
      key: 'customers',
      title: 'Customers',
      icon: 'groups',
      gradient: 'from-cyan-500 to-blue-500',
    },
    {
      key: 'certificates',
      title: 'Certificates',
      icon: 'workspace_premium',
      gradient: 'from-rose-500 to-red-500',
    },
  ];
  const formatNumber = (num) =>
    num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }
      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const [preSelectedFilter] = useState({
    value: 10,
    label: '10',
  });
  const status = 'active';
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const togglePopupShare = () => {
    setisOpenShare(!isOpenShare);
    setEmail('');
  };
  const togglePopupManageAccess = (user) => {
    setisOpenManageAccess(!isOpenManageAccess);
    setCurrentUser(user);
  };
  const handleFilterChange = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  const [permissions, setPermissions] = useState([
    { id: 'view_certificate', label: 'View Certificate', enabled: true },
    { id: 'view_document', label: 'View Document', enabled: false },
    { id: 'download_document', label: 'Download Document', enabled: false },
  ]);

  const togglePermission = (id) => {
    setPermissions((prev) =>
      prev.map((p) => (p.id === id ? { ...p, enabled: !p.enabled } : p)),
    );
  };
  const getAgencyDashboardStats = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/agency/dashboard/stats`);

      if (response.status == 200) {
        setData(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          showToast(response.message, 'error');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const getAgentDashboardStats = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/agent/dashboard/stats`);

      if (response.status == 200) {
        setData(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          showToast(response.message, 'error');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  useEffect(() => {
    if (roleName == 'agency_compliance' || roleName == 'agency') {
      getAgencyDashboardStats();
    }
    if (roleName == 'agent') {
      getAgentDashboardStats();
    }
  }, [roleName]);
  return (
    <div className=" lg:min-w-[79vw] lg:max-w-[80vw]">
      {isLoadingCard ? (
        <div className="shimmer-container-list mb-4 ">
          {/* Creating 5 rows of shimmer effect */}
          {[...Array(2)].map((_, rowIndex) => (
            <div key={rowIndex} className="shimmer-row-list">
              {/* Creating 7 cells in each row for shimmer */}
              {[...Array(2)].map((_, colIndex) => (
                <div key={colIndex} className="shimmer-cell-list h-20">
                  <div className="shimmer-loader"></div>
                </div>
              ))}
            </div>
          ))}
        </div>
      ) : (
        <>
          {roleName == 'customer' && (
            <>
              <CertificateManagement />
            </>
          )}
          {/* {roleName == 'agency' && <AgencyDashboard />} */}
          {roleName == 'agency' && <BusinessDashboard />}

          {roleName == 'agency_compliance' && (
            <>
              {/* <ComplianceDashboard /> */}

              {/* <>
                <div className="p-4 sm:p-5 lg:p-6">
                  <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-2">
                    {statsConfigAgency.map((item) => {
                      const stat = data?.[item.key] || {};

                      const breakdownItems = [
                        {
                          key: 'active',
                          label: 'Active',
                          value: stat.active,
                          icon: 'check_circle',
                          className:
                            'border-emerald-100 bg-emerald-50/70 text-emerald-700',
                          iconClass: 'bg-emerald-100 text-emerald-600',
                        },
                        {
                          key: 'pending_review',
                          label: 'Pending Review',
                          value: stat.pending_review,
                          icon: 'pending_actions',
                          className:
                            'border-amber-100 bg-amber-50/70 text-amber-700',
                          iconClass: 'bg-amber-100 text-amber-600',
                        },
                        {
                          key: 'pending',
                          label: 'Pending',
                          value: stat.pending,
                          icon: 'schedule',
                          className:
                            'border-orange-100 bg-orange-50/70 text-orange-700',
                          iconClass: 'bg-orange-100 text-orange-600',
                        },
                        {
                          key: 'this_month',
                          label: 'This Month',
                          value: stat.this_month,
                          icon: 'trending_up',
                          className:
                            'border-blue-100 bg-blue-50/70 text-blue-700',
                          iconClass: 'bg-blue-100 text-blue-600',
                        },
                        {
                          key: 'last_month',
                          label: 'Last Month',
                          value: stat.last_month,
                          icon: 'calendar_month',
                          className:
                            'border-slate-200 bg-slate-50/80 text-slate-700',
                          iconClass: 'bg-slate-100 text-slate-600',
                        },
                      ].filter((item) => item.key in stat);

                      return (
                        <div
                          key={item.key}
                          className="group relative overflow-hidden rounded-[24px] border border-slate-200/80 bg-white shadow-[0_8px_30px_rgba(15,23,42,0.06)] transition-all duration-300 hover:-translate-y-1 hover:border-slate-300 hover:shadow-[0_18px_45px_rgba(15,23,42,0.10)]"
                        >
                          <div className="pointer-events-none absolute -right-12 -top-12 h-32 w-32 rounded-full bg-slate-100/70 blur-2xl transition-all duration-500 group-hover:scale-125" />
                          <div
                            className={`absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r ${item.gradient}`}
                          />

                          <div className="relative p-5 sm:p-6">
                            <div className="flex items-start justify-between gap-4">
                              <div className="flex min-w-0 items-center gap-3.5">
                                <div
                                  className={`relative flex h-12 w-12 shrink-0 items-center justify-center rounded-[16px] bg-gradient-to-br ${item.gradient} text-white shadow-lg transition-transform duration-300 group-hover:scale-105`}
                                >
                                  <span className="material-symbols-outlined text-[22px]">
                                    {item.icon}
                                  </span>
                                  <span className="absolute inset-0 rounded-[16px] bg-white/10" />
                                </div>

                                <div className="min-w-0">
                                  <p className="truncate text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-400">
                                    Overview
                                  </p>

                                  <h3 className="mt-0.5 truncate text-[15px] font-bold text-slate-800">
                                    {item.title}
                                  </h3>
                                </div>
                              </div>
                              <div className="hidden shrink-0 items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1.5 text-[10px] font-medium text-slate-500 sm:flex">
                                <span className="material-symbols-outlined text-[13px]">
                                  calendar_today
                                </span>
                                {new Date().toLocaleDateString('en-AU', {
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric',
                                })}
                              </div>
                            </div>
                            <div className="mt-6 flex items-end justify-between gap-3">
                              <div>
                                <p className="text-xs font-medium text-slate-400">
                                  Total
                                </p>

                                <div className="mt-1 text-[32px] font-extrabold leading-none tracking-tight text-slate-900 sm:text-[36px]">
                                  {formatNumber(stat.total || 0)}
                                </div>
                              </div>
                              <div className="mb-1 flex h-9 w-9 items-center justify-center rounded-xl bg-slate-50 text-slate-400 transition-colors group-hover:bg-slate-100">
                                <span className="material-symbols-outlined text-[19px]">
                                  analytics
                                </span>
                              </div>
                            </div>
                            {breakdownItems.length > 0 && (
                              <div className="my-5 h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent" />
                            )}
                            {breakdownItems.length > 0 && (
                              <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2">
                                {breakdownItems.map((breakdown) => (
                                  <div
                                    key={breakdown.key}
                                    className={`flex items-center justify-between gap-3 rounded-[14px] border px-3 py-2.5 transition-all duration-200 hover:-translate-y-0.5 ${breakdown.className}`}
                                  >
                                    <div className="flex min-w-0 items-center gap-2">
                                      <div
                                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg ${breakdown.iconClass}`}
                                      >
                                        <span className="material-symbols-outlined text-[15px]">
                                          {breakdown.icon}
                                        </span>
                                      </div>

                                      <span className="truncate text-[11px] font-semibold">
                                        {breakdown.label}
                                      </span>
                                    </div>

                                    <span className="text-sm font-extrabold">
                                      {formatNumber(breakdown.value || 0)}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            )}
                            {item.key === 'customers' &&
                              stat.by_type &&
                              Object.keys(stat.by_type).length > 0 && (
                                <div className="mt-5 border-t border-slate-100 pt-4">
                                  <div className="mb-3 flex items-center gap-2">
                                    <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-indigo-50 text-indigo-600">
                                      <span className="material-symbols-outlined text-[16px]">
                                        category
                                      </span>
                                    </div>

                                    <div>
                                      <p className="text-xs font-bold text-slate-700">
                                        Customer Types
                                      </p>
                                      <p className="text-[10px] text-slate-400">
                                        Distribution by type
                                      </p>
                                    </div>
                                  </div>

                                  <div className="flex flex-wrap gap-2">
                                    {Object.entries(stat.by_type).map(
                                      ([key, val]) => (
                                        <div
                                          key={key}
                                          className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5 transition-colors hover:border-indigo-200 hover:bg-indigo-50"
                                        >
                                          <span className="h-1.5 w-1.5 rounded-full bg-indigo-500" />

                                          <span className="text-[10px] font-semibold capitalize text-slate-600">
                                            {key.replace(/_/g, ' ')}
                                          </span>

                                          <span className="text-[11px] font-extrabold text-slate-900">
                                            {formatNumber(val || 0)}
                                          </span>
                                        </div>
                                      ),
                                    )}
                                  </div>
                                </div>
                              )}

                            <div className="mt-5 flex items-center justify-between border-t border-slate-100 pt-4">
                              <div className="flex items-center gap-2">
                                <span className="relative flex h-2 w-2">
                                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-50" />
                                  <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
                                </span>

                                <span className="text-[10px] font-medium text-slate-400">
                                  Live data
                                </span>
                              </div>

                              <span className="text-[10px] font-medium text-slate-400">
                                Updated today
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </> */}
              {/* <div className="p-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5">
                  {statsConfigAgent.map((item) => {
                    const stat = data?.[item.key] || {};

                    return (
                      <div
                        key={item.key}
                        className="relative bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden"
                      >
                        <div
                          className={`h-2 w-full bg-gradient-to-r ${item.gradient}`}
                        />

                        <div className="p-5">
                          <div className="flex items-center justify-between mb-4">
                            <div className="flex items-center gap-3">
                              <div
                                className={`p-2 rounded-xl bg-gradient-to-r ${item.gradient} text-white`}
                              >
                                <span className="material-symbols-outlined text-xl">
                                  {item.icon}
                                </span>
                              </div>
                              <h3 className="text-sm font-semibold text-gray-700">
                                {item.title}
                              </h3>
                            </div>

                            <span className="text-xs text-gray-400">
                              {new Date().toLocaleDateString()}
                            </span>
                          </div>
                          <div className="text-3xl font-bold text-gray-900 mb-4">
                            {formatNumber(stat.total || 0)}
                          </div>
                          <div className="grid grid-cols-2 gap-3 text-xs">
                            {"active" in stat && (
                              <div className="bg-green-50 text-green-700 px-3 py-2 rounded-lg flex justify-between">
                                <span>Active</span>
                                <span className="font-semibold">
                                  {stat.active}
                                </span>
                              </div>
                            )}

                            {"pending_review" in stat && (
                              <div className="bg-yellow-50 text-yellow-700 px-3 py-2 rounded-lg flex justify-between">
                                <span>Pending</span>
                                <span className="font-semibold">
                                  {stat.pending_review}
                                </span>
                              </div>
                            )}

                            {"pending" in stat && (
                              <div className="bg-yellow-50 text-yellow-700 px-3 py-2 rounded-lg flex justify-between">
                                <span>Pending</span>
                                <span className="font-semibold">
                                  {stat.pending}
                                </span>
                              </div>
                            )}

                            {"this_month" in stat && (
                              <div className="bg-blue-50 text-blue-700 px-3 py-2 rounded-lg flex justify-between">
                                <span>This Month</span>
                                <span className="font-semibold">
                                  {stat.this_month}
                                </span>
                              </div>
                            )}

                            {"last_month" in stat && (
                              <div className="bg-gray-100 text-gray-700 px-3 py-2 rounded-lg flex justify-between">
                                <span>Last Month</span>
                                <span className="font-semibold">
                                  {stat.last_month}
                                </span>
                              </div>
                            )}
                          </div>
                          {item.key === "customers" && stat.by_type && (
                            <div className="mt-4 border-t pt-3">
                              <div className="text-xs text-gray-500 mb-2">
                                Type
                              </div>
                              <div className="flex flex-wrap gap-2">
                                {Object.entries(stat.by_type).map(
                                  ([key, val]) => (
                                    <span
                                      key={key}
                                      className="text-[10px] bg-gray-100 px-2 py-1 rounded-full"
                                    >
                                      {key.replace("_", " ")}: {val}
                                    </span>
                                  ),
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="w-full p-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 font-medium">
                  <div
                    onClick={() => setShowModal(true)}
                    className="cursor-pointer bg-white rounded-2xl shadow-md p-6 hover:shadow-xl transition-all border hover:border-blue-400"
                  >
                    <div className="text-3xl mb-3">📊</div>
                    <h3 className="text-lg font-semibold mb-1">
                      Generate Audit Report
                    </h3>
                    <p className="text-sm text-gray-500">
                      Create compliance audit reports for clients
                    </p>
                  </div>
                  <div
                    onClick={() => {
                      setIsConfirmVerify(true);
                    }}
                    className="cursor-pointer bg-white rounded-2xl shadow-md p-6 hover:shadow-xl transition-all border hover:border-green-400"
                  >
                    <div className="text-3xl mb-3">🛡️</div>
                    <h3 className="text-lg font-semibold mb-1">
                      AML / CTF Program
                    </h3>
                    <p className="text-sm text-gray-500">View AML/CTF report</p>
                  </div>
                  <div
                    onClick={() => navigate("/training")}
                    className="cursor-pointer bg-white rounded-2xl shadow-md p-6 hover:shadow-xl transition-all border hover:border-purple-400"
                  >
                    <div className="text-3xl mb-3">🎓</div>
                    <h3 className="text-lg font-semibold mb-1">Training</h3>
                    <p className="text-sm text-gray-500">
                      Access compliance training resources
                    </p>
                  </div>
                </div>

                {showModal && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
                    <div className="bg-white rounded-2xl p-6 w-[90%] max-w-md shadow-lg">
                      <h2 className="text-xl font-semibold mb-4">
                        Generate Audit Report
                      </h2>

                      <input
                        type="text"
                        placeholder="Enter Client Name"
                        value={clientName}
                        onChange={(e) => setClientName(e.target.value)}
                        className="w-full p-3 border rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-blue-400"
                      />

                      <div className="flex justify-end gap-3">
                        <button
                          onClick={() => setShowModal(false)}
                          className="px-4 py-2 border rounded-lg"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={handleGenerateReport}
                          className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                        >
                          Generate
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div> */}
            </>
          )}
          {roleName == 'agent' && (
            // <AgentDashboard />
            <>
              <div className="p-4 sm:p-5 lg:p-6">
                <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
                  {statsConfigAgent.map((item) => {
                    const stat = data?.[item.key] || {};

                    const breakdownItems = [
                      {
                        key: 'active',
                        label: 'Active',
                        value: stat.active,
                        icon: 'check_circle',
                        className:
                          'border-emerald-100 bg-emerald-50/70 text-emerald-700',
                        iconClass: 'bg-emerald-100 text-emerald-600',
                      },
                      {
                        key: 'pending_review',
                        label: 'Pending Review',
                        value: stat.pending_review,
                        icon: 'pending_actions',
                        className:
                          'border-amber-100 bg-amber-50/70 text-amber-700',
                        iconClass: 'bg-amber-100 text-amber-600',
                      },
                      {
                        key: 'pending',
                        label: 'Pending',
                        value: stat.pending,
                        icon: 'schedule',
                        className:
                          'border-orange-100 bg-orange-50/70 text-orange-700',
                        iconClass: 'bg-orange-100 text-orange-600',
                      },
                      {
                        key: 'this_month',
                        label: 'This Month',
                        value: stat.this_month,
                        icon: 'trending_up',
                        className:
                          'border-blue-100 bg-blue-50/70 text-blue-700',
                        iconClass: 'bg-blue-100 text-blue-600',
                      },
                      {
                        key: 'last_month',
                        label: 'Last Month',
                        value: stat.last_month,
                        icon: 'calendar_month',
                        className:
                          'border-slate-200 bg-slate-50/80 text-slate-700',
                        iconClass: 'bg-slate-100 text-slate-600',
                      },
                    ].filter((item) => item.key in stat);

                    return (
                      <div
                        key={item.key}
                        className="group relative overflow-hidden rounded-[24px] border border-slate-200/80 bg-white shadow-[0_8px_30px_rgba(15,23,42,0.06)] transition-all duration-300 hover:-translate-y-1 hover:border-slate-300 hover:shadow-[0_18px_45px_rgba(15,23,42,0.10)]"
                      >
                        {/* Decorative background */}
                        <div className="pointer-events-none absolute -right-12 -top-12 h-32 w-32 rounded-full bg-slate-100/70 blur-2xl transition-all duration-500 group-hover:scale-125" />

                        {/* Gradient accent */}
                        <div
                          className={`absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r ${item.gradient}`}
                        />

                        <div className="relative p-5 sm:p-6">
                          {/* Header */}
                          <div className="flex items-start justify-between gap-4">
                            <div className="flex min-w-0 items-center gap-3.5">
                              {/* Icon */}
                              <div
                                className={`relative flex h-12 w-12 shrink-0 items-center justify-center rounded-[16px] bg-gradient-to-br ${item.gradient} text-white shadow-lg transition-transform duration-300 group-hover:scale-105`}
                              >
                                <span className="material-symbols-outlined text-[22px]">
                                  {item.icon}
                                </span>

                                {/* Small glow */}
                                <span className="absolute inset-0 rounded-[16px] bg-white/10" />
                              </div>

                              <div className="min-w-0">
                                <p className="truncate text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-400">
                                  Overview
                                </p>

                                <h3 className="mt-0.5 truncate text-[15px] font-bold text-slate-800">
                                  {item.title}
                                </h3>
                              </div>
                            </div>

                            {/* Date */}
                            <div className="hidden shrink-0 items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1.5 text-[10px] font-medium text-slate-500 sm:flex">
                              <span className="material-symbols-outlined text-[13px]">
                                calendar_today
                              </span>
                              {new Date().toLocaleDateString('en-AU', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                              })}
                            </div>
                          </div>

                          {/* Main number */}
                          <div className="mt-6 flex items-end justify-between gap-3">
                            <div>
                              <p className="text-xs font-medium text-slate-400">
                                Total
                              </p>

                              <div className="mt-1 text-[32px] font-extrabold leading-none tracking-tight text-slate-900 sm:text-[36px]">
                                {formatNumber(stat.total || 0)}
                              </div>
                            </div>

                            {/* Total badge */}
                            <div className="mb-1 flex h-9 w-9 items-center justify-center rounded-xl bg-slate-50 text-slate-400 transition-colors group-hover:bg-slate-100">
                              <span className="material-symbols-outlined text-[19px]">
                                analytics
                              </span>
                            </div>
                          </div>

                          {/* Divider */}
                          {breakdownItems.length > 0 && (
                            <div className="my-5 h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent" />
                          )}

                          {/* Breakdown */}
                          {breakdownItems.length > 0 && (
                            <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2">
                              {breakdownItems.map((breakdown) => (
                                <div
                                  key={breakdown.key}
                                  className={`flex items-center justify-between gap-3 rounded-[14px] border px-3 py-2.5 transition-all duration-200 hover:-translate-y-0.5 ${breakdown.className}`}
                                >
                                  <div className="flex min-w-0 items-center gap-2">
                                    <div
                                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg ${breakdown.iconClass}`}
                                    >
                                      <span className="material-symbols-outlined text-[15px]">
                                        {breakdown.icon}
                                      </span>
                                    </div>

                                    <span className="truncate text-[11px] font-semibold">
                                      {breakdown.label}
                                    </span>
                                  </div>

                                  <span className="text-sm font-extrabold">
                                    {formatNumber(breakdown.value || 0)}
                                  </span>
                                </div>
                              ))}
                            </div>
                          )}

                          {/* Customer Types */}
                          {item.key === 'customers' &&
                            stat.by_type &&
                            Object.keys(stat.by_type).length > 0 && (
                              <div className="mt-5 border-t border-slate-100 pt-4">
                                <div className="mb-3 flex items-center gap-2">
                                  <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-indigo-50 text-indigo-600">
                                    <span className="material-symbols-outlined text-[16px]">
                                      category
                                    </span>
                                  </div>

                                  <div>
                                    <p className="text-xs font-bold text-slate-700">
                                      Customer Types
                                    </p>
                                    <p className="text-[10px] text-slate-400">
                                      Distribution by type
                                    </p>
                                  </div>
                                </div>

                                <div className="flex flex-wrap gap-2">
                                  {Object.entries(stat.by_type).map(
                                    ([key, val]) => (
                                      <div
                                        key={key}
                                        className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5 transition-colors hover:border-indigo-200 hover:bg-indigo-50"
                                      >
                                        <span className="h-1.5 w-1.5 rounded-full bg-indigo-500" />

                                        <span className="text-[10px] font-semibold capitalize text-slate-600">
                                          {key.replace(/_/g, ' ')}
                                        </span>

                                        <span className="text-[11px] font-extrabold text-slate-900">
                                          {formatNumber(val || 0)}
                                        </span>
                                      </div>
                                    ),
                                  )}
                                </div>
                              </div>
                            )}

                          {/* Bottom status */}
                          <div className="mt-5 flex items-center justify-between border-t border-slate-100 pt-4">
                            <div className="flex items-center gap-2">
                              <span className="relative flex h-2 w-2">
                                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-50" />
                                <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
                              </span>

                              <span className="text-[10px] font-medium text-slate-400">
                                Live data
                              </span>
                            </div>

                            <span className="text-[10px] font-medium text-slate-400">
                              Updated today
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </>
          )}
        </>
      )}

      {isOpenShare && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg w-[90%] md:w-[700px] p-6">
            {/* Modal Header */}
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-medium text-center w-full">
                Share Certificate
              </h2>
              <button onClick={togglePopupShare}>
                <img src="/add.svg" alt="Close" className="w-10 h-10" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="grid grid-cols-1 gap-6 items-center">
              <div className="space-y-4 mx-auto ">
                <div className="mb-4">
                  <label
                    htmlFor="email"
                    className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                  >
                    Email<span className="text-red-500">*</span>
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="text"
                    value={email}
                    autoComplete="off"
                    placeholder="example@gmail.com"
                    className={`rounded-lg h-[2.813rem] dark:text-white text-black text-base font-medium  appearance-none  w-full py-2 px-3 leading-tight focus:outline-none ${
                      email != '' && !validateEmail(email)
                        ? 'border-[#FF5050] border-2'
                        : 'border'
                    }`}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {email != '' && !validateEmail(email) && (
                    <label
                      htmlFor="confirmpassword"
                      className="flex mt-1 items-center font-normal text-xs text-[#FF5050] mb-1"
                    >
                      <img
                        src="/danger.svg"
                        alt="alert Icon"
                        className="h-4 w-4 mr-2"
                      />
                      Please enter a valid email address.
                    </label>
                  )}
                </div>
                <div className="mb-4">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      if (!validateEmail(email)) {
                        showToast(
                          'Please enter a valid email address.',
                          'error',
                        );
                        return;
                      }
                    }}
                    className="flex items-center justify-center gap-2 px-6 py-2 w-full rounded-lg bg-[#375AE7] text-white hover:bg-gray-800 transition"
                  >
                    <span className="material-icons text-white text-[20px]">
                      download
                    </span>
                    Download Certificate
                  </button>
                </div>

                <div className="mb-4">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      if (!validateEmail(email)) {
                        showToast(
                          'Please enter a valid email address.',
                          'error',
                        );
                        return;
                      }
                    }}
                    className="flex items-center justify-center gap-2 px-6 py-2 w-full rounded-lg bg-[#375AE7] text-white hover:bg-gray-800 transition"
                  >
                    <span className="material-icons text-white text-[20px]">
                      share
                    </span>
                    Share Certificate with Documents
                  </button>
                </div>

                <div className="mb-4">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      if (!validateEmail(email)) {
                        showToast(
                          'Please enter a valid email address.',
                          'error',
                        );
                        return;
                      }
                    }}
                    className="flex items-center justify-center gap-2 px-6 py-2 w-full rounded-lg bg-[#375AE7] text-white hover:bg-gray-800 transition"
                  >
                    <span className="material-icons text-white text-[20px]">
                      content_copy
                    </span>
                    Copy Certificate Link
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpenManageAccess && currentUser != null && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-black/60  z-50 p-4">
          <div className="bg-white text-black rounded-2xl w-full max-w-md md:max-w-lg p-6 shadow-xl">
            {/* Header */}
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold">{currentUser.name}</h2>

              <button
                onClick={() => {
                  setisOpenManageAccess(false);
                  setCurrentUser(null);
                }}
              >
                <span className="material-icons text-black">close</span>
              </button>
            </div>

            {/* Permissions */}
            <div className="space-y-5">
              {permissions.map((perm) => (
                <div
                  key={perm.id}
                  className="flex items-center justify-between"
                >
                  <p className="text-md text-black">{perm.label}</p>

                  {/* Toggle */}
                  <button
                    onClick={() => togglePermission(perm.id)}
                    className={`relative w-12 h-6 rounded-full transition ${
                      perm.enabled ? 'bg-[#375AE7]' : 'bg-[#7F8287]'
                    }`}
                  >
                    <span
                      className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full transition ${
                        perm.enabled ? 'translate-x-6' : ''
                      }`}
                    />
                  </button>
                </div>
              ))}
            </div>

            {/* Buttons */}
            <div className="flex justify-center gap-4 mt-8">
              <button
                onClick={() => {
                  setisOpenManageAccess(false);
                  setCurrentUser(null);
                }}
                className="px-6 py-2 rounded-full text-white bg-[#375AE7] hover:bg-gray-800"
              >
                Cancel
              </button>

              <button className="px-6 py-2 rounded-full text-white bg-[#375AE7] hover:bg-gray-800">
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardDetails;
